window.MobileAppDownloadButton = (function () {

    function handleDownloadClick(url) {
        var site = window.globalAppSettings.api.appSource || 'UniRu';
        var apkName = site === 'UniRu' ? 'BaltBet.apk' : 'Yodds.apk';
        var link = document.createElement('a');
        link.setAttribute('href', url);
        link.setAttribute('download', apkName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        link.remove();

        return false;
    }

    function bindUI() {
        document.addEventListener('click', function (e) {
            if (e.target.classList.contains('js-app-download-button')) {
                const button = e.target.dataset.href ? e.target : e.target.parentNode;
                if (button.dataset.href) {
                    return handleDownloadClick(button.dataset.href);
                }
            }
        });
    }

    return {
        bindUI: bindUI
    }
}());

MobileAppDownloadButton.bindUI();